export const COPY_SUCCESS_INFO = {
  title: 'Success',
  content: 'Copied to clipboard.',
};

export default {};
